"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

var _interopRequireWildcard = require("@babel/runtime/helpers/interopRequireWildcard");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = AaModal;

var React = _interopRequireWildcard(require("react"));

var _reactNativeWeb = require("react-native-web");

var _StyleSheet = _interopRequireDefault(require("../../PlatformStyleSheet/StyleSheet"));

var _index = require("./index");

function AaModal(_ref) {
  var children = _ref.children,
      isVisible = _ref.isVisible,
      wrapperStyle = _ref.wrapperStyle,
      modalStyle = _ref.modalStyle,
      onClose = _ref.onClose,
      isClosingOnBackdropPress = _ref.isClosingOnBackdropPress,
      backdropColor = _ref.backdropColor,
      backdropOpacity = _ref.backdropOpacity;
  var centerContent = _reactNativeWeb.Platform.OS === 'web';
  return /*#__PURE__*/React.createElement(_index.Modal, {
    isVisible: isVisible,
    onRequestClose: onClose,
    onBackdropPress: isClosingOnBackdropPress ? onClose : undefined,
    style: [styles.modal, centerContent && styles.modalCentered, modalStyle],
    backdropColor: backdropColor,
    backdropOpacity: backdropOpacity
  }, /*#__PURE__*/React.createElement(_reactNativeWeb.SafeAreaView, {
    style: [styles.content, centerContent && styles.contentCentered, wrapperStyle]
  }, children));
}

AaModal.defaultProps = {
  isClosingOnBackdropPress: true
};

var styles = _StyleSheet["default"].create({
  modal: {
    margin: 0,
    zIndex: 999999,
    elevation: 999999,
    backgroundColor: 'rgba(0,0,0,0.7)'
  },
  content: {
    width: '100%',
    zIndex: 999,
    elevation: 999,
    backgroundColor: 'transparent'
  },
  contentCentered: {
    width: '100%',
    zIndex: 999,
    elevation: 999,
    borderRadius: parseInt(6, 10),
    paddingTop: 0,
    paddingBottom: 0
  }
});